import * as React from "react";
import { pure } from "recompose";
import LayoutGrid from "@tunnel-components/layouts/layout/index";
import BreadCrumb from "@tunnel-components/@sharded/widgets/breadcrumb/component";
import * as Paths from "@tunnel-enums/index";
import * as i18next from "i18next";
import * as Lodash from "lodash";
import OngletIncident from "@tunnel-components/@sharded/widgets/onglet-navigation/component";
import MessageEmptyIncidents from "@tunnel-components/@sharded/message/component";
import VirtualCameraTmdLapiPagination from "@tunnel-components/@sharded/@widgets/camera-tmd-lapi/component";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  // desturation
  const {
    cameraListData,
    totalElements,
    onUpdateCurrentPageNumber,
    currentPageNumbers,
    itemsPerPage,
    onClickOnglet,
    itemPerRow,
    onChangeItemPerRow,
  } = props;

  const onglet: any[] = [
    {
      title: i18next.t("toutes"),
      action: "",
    },
  ];

  return (
    <LayoutGrid
      incidentPerRow={true}
      authorization={true}
      onChangeItemPerRow={onChangeItemPerRow}
    >
      <section className="tunnel-site animated fadeIn">
        {Lodash.isEqual(totalElements, 0) &&
          !Lodash.isUndefined(totalElements) && (
            <MessageEmptyIncidents
              message={i18next.t("Il ny a pas de cameras")}
              emptyIncident={false}
            />
          )}
        {!Lodash.isEqual(totalElements, 0) &&
          !Lodash.isUndefined(totalElements) && (
            <BreadCrumb
              links1={Paths.PathsNamesEnums.TMDLAPICAMERAS}
              width="26"
              height="26"
              lapiincons={true}
              title={i18next.t("tmdLapi")}
              breadText1={i18next.t("cameras")}
            />
          )}
        {!Lodash.isEqual(totalElements, 0) &&
          !Lodash.isUndefined(totalElements) && (
            <OngletIncident
              onglet={onglet}
              ongletActive={[true]}
              onClickOnglet={onClickOnglet}
            />
          )}
        <div className="contentAllSite">
          <div id="columns" className="with-3-columns">
            <VirtualCameraTmdLapiPagination
              grid={true}
              cameraListData={cameraListData}
              itemsPerPage={itemsPerPage}
              currentPageNumbers={currentPageNumbers}
              onUpdateCurrentPageNumber={onUpdateCurrentPageNumber}
              itemPerRow={itemPerRow}
              totalElements={totalElements}
              totalRowElements={cameraListData && cameraListData.length}
            />
          </div>
        </div>
      </section>
    </LayoutGrid>
  );
};

/** Valeurs par défaut des props */
Component.defaultProps = {};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  loading?: any;
  onUpdateCurrentPageNumber?: any;
  cameraListData?: any;
  currentPageNumbers?: any;
  itemsPerPage?: any;
  itemPerRow?: any;
  onChangeItemPerRow?: any;
  onClickOnglet?: any;
  totalElements?: any;
}
/** @export HOC pure */
export default pure(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/lapi-tmd/cameras/component.tsx